<app-accordion-help [helps]="helps"></app-accordion-help>

<!--<app-cagad-select [is_campaign]=true [start_date]="start_date"  [end_date]="end_date"  [network]="network" [is_network]=false [account_id]="account_id" (newItemEvent)= "selectCagadValue($event)"></app-cagad-select>-->

<!--<app-network-select [account_id]="account_id" (newItemEventNetwork)= "selectValueNetwork($event)"></app-network-select>-->
<!--<br>-->
<!--<app-cagad-select-->
<!--  *ngIf="network_id"-->
<!--  [hide_adgroups]=false-->
<!--  [hide_ads]=false-->
<!--  [account_id]="account_id"-->
<!--  [start_date]="start_date"-->
<!--  [end_date]="end_date"-->
<!--  [network_id]="network_id"-->
<!--  (newItemEventCampaign)= "selectCagadValueCampaign($event)"-->
<!--  (newItemEventAdgroup)= "selectCagadValueAdgroup($event)"-->
<!--  (newItemEventAd)= "selectCagadValueAd($event)">-->
<!--</app-cagad-select>-->

<ng-container *ngIf="code">

  <div ngClass.xs="page-margin-xs"
       ngClass.sm="page-margin-sm"
       ngClass="page-margin">
    <mat-card>

      <mat-card-content>
        <pre><code [highlight]="code" [languages]="['typescript']" (highlighted)="onHighlight($event)" [lineNumbers]="false"></code></pre>
      </mat-card-content>


    </mat-card>

    <br>
    <mat-card>


      <mat-card-content>
        <pre><code [highlight]="code_angle" [languages]="['typescript']" (highlighted)="onHighlight($event)" [lineNumbers]="false"></code></pre>
      </mat-card-content>


    </mat-card>

  </div>

<!--  <button (click)="changeTheme()">Change theme</button>-->

</ng-container>












<!--<ng-container matColumnDef="expandedDetail">-->
<!--  <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">-->
<!--    <div class="element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">-->
<!--      <div class="element-script">-->
<!--        <code [highlight]="element.script"></code>-->
<!--        <button mat-icon-button (click)="copyToClipboard(element.script)">-->
<!--          <i class="material-icons">file_copy</i>-->
<!--        </button>-->
<!--      </div>-->
<!--    </div>-->
<!--  </td>-->
<!--</ng-container>-->

<!--description: tag.meta.description,-->
<!--script: `-->
<!--<script type="text/javascript">-->
<!--  var _c = new Date().getTime();-->
<!--  var tag_id ="${tag.meta.tag_id}";-->
<!--  var browser_url = window.location.href;-->
<!--  var data = {browser_url: browser_url};-->
<!--  var base64data = btoa(JSON.stringify(data));-->
<!--  var url =  "${environment.tag_url}?tag_id=" + tag_id + "&cache_buster=" + _c + "&data=" + base64data;-->
<!--  var js_script = '<script type="text/javascript" src="' + url  +  '" async> </\script>';-->
<!--  document.write(js_script);-->
<!--</script>-->
<!--`-->
